import React from 'react';
import {connect} from 'react-redux';
import {Drawer} from "@material-ui/core";
import List from '@material-ui/core/List';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import HelpIcon from '@material-ui/icons/Help';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {showHelp} from "../../store/modalsSlice";
import {setSidebar} from "../../store/coreSlice";

import Button from "@material-ui/core/Button";
import ZoneList from "./ZoneList/ZoneList";
import {useHistory} from "react-router";

// TODO: this is copypasta'd from Grocery

const SidebarMenu = (props) => {
	const history = useHistory();
	// const onOpen = () => {
	// 	console.log("onOpen");
	// 	props.setSidebar(true);
	// };

	const onClose = () => {
		// props.setSidebar(false);
	};
	//
	// const goto = (url) => {
	// 	// history.push(url);
	// 	props.setSidebar(false);
	// };

	const addZone = () => {
		history.push('/add-zone')
	};

	const onClickHome = () => {
		document.location = '/';
	};

	const onClickHelp = () => {
		props.showHelp(true);
	};

	return (
		<Drawer className={props.drawerClass} onClose={onClose} open={props.sidebar}
				classes={{paper: props.paperClass}}
				variant="persistent"
				anchor="left"
				// className={css.SidebarMenu}
		>

			<h3 style={{textAlign: 'center', margin: '5px 0'}}>A2PoGo Spawn Alerts</h3>

			<div style={{display: 'flex', margin: "5px 7px 0"}}>
				<Button startIcon={<ArrowBackIcon />} onClick={onClickHome} variant="contained" style={{flex: 1, margin: "0 3px"}}>
					Home
				</Button>

				<Button startIcon={<HelpIcon/>} onClick={onClickHelp} variant="contained" style={{flex: 1, margin: "0 3px"}}>
					Help
				</Button>
			</div>

			<Button startIcon={<AddLocationIcon/>}
					variant="contained"
					color="primary"
					style={{margin: "10px 10px 0"}}
					onClick={addZone}>Add Zone</Button>

			<List>
				<ZoneList />
			</List>
		</Drawer>
	);
};

const mapStateToProps = (state) => {
	return {
		sidebar: state.core.sidebar
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setSidebar: (value) => dispatch(setSidebar(value)),
		showHelp: (value) => dispatch(showHelp(value))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);